import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import {Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import moment from 'moment'

import { SERVER_ } from  '../../config';


import Dialog from '../../services/Dialogs'

const ModalCargarAccesos = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, visita } = params


  const [ tiene_acceso, setTiene_acceso ] = useState<any>({
    empleado_anexos : []
  })
  const [ envio_server, setSeEnvio ] = useState<boolean>(false)
  const cargarTiene_acceso = async()=>{
    try{
      setSeEnvio(true)
      let response : any = await RequestService.getEndPoint(`calendario/visita/informacion_acceso/${visita.uuid}`)
      setTiene_acceso(response.data)
      setSeEnvio(false)
    }
    catch(e){
      setSeEnvio(false)
      toast.error('Problemas al intentar cargar')
    }
  }


  React.useEffect(() => {
    cargarTiene_acceso()
  }, []);




  const [ anexo_archivo_subir, setArchivoSubir ] = useState<any>('')


  const handleFileRead = async (event:any) => {
    const file = event.target.files[0]
    const base64 = await convertBase64(file)
    setArchivoSubir(base64)
  }


  const convertBase64 = (file:any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }




const dialog = new Dialog();

const enviarAnexo = async (event:any) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `calendario/cargar_anexo_acceso/${visita.uuid}` , { archivo : anexo_archivo_subir.split(',')[1] })

        if(res_){
          toast.success('El Anexo se agregó correctamente')
          setTimeout(()=>{
            cargarTiene_acceso()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){

          if (e.response?.status) {
            switch (e.response.status) {
              case 404:
                toast.error("Debes escribir algo")
                break;
              default:
                toast.error(e.response?.data)
            }
          }
          else{
            toast.error("Problemas con la busqueda")
          }
          setSeEnvio(false)

        }
        
      }
     
}









const eliminarPermisoAcceso = async (event:any,uuid_visita:string) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro?',
        target: event.target,
        template: ``
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.delete( `calendario/eliminar_permiso_acceso/${uuid_visita}` )

        if(res_){
          toast.success('Consulta_correcta')
          setTimeout(()=>{
            cargarTiene_acceso()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){

          if (e.response?.status) {
            switch (e.response.status) { 
              default:
                toast.error(e.response?.data)
            }
          }
          else{
            toast.error("No pudimos eliminar el registro")
          }
          setSeEnvio(false)

        }
        
      }
     
}



  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Cargar Acceso de Visita</Modal.Title>
        </Modal.Header>

          <div className={`text-center mb-2 tipo_orden_${visita.idtipo_orden.id}`}>
            <small>Tipo de Visita</small>
            <h5 className="nm">{visita.idtipo_orden.tipo_orden}</h5>
          </div>

        <Modal.Body>

          <small>Técnico</small>
          <h5>{visita.idtecnico.nombres} {visita.idtecnico.paterno} {visita.idtecnico.materno}</h5>


          {
            tiene_acceso.empleado_anexos.length > 0 && (
                <React.Fragment>
                  
                    <small>Documentación</small>
                    <ol>
                      {
                        tiene_acceso.empleado_anexos.map((anexo:any,anexo_indice:number)=>
                            <React.Fragment>
                              {
                                anexo.idtipo_documento.debe_visualizar_cliente && (
                                      <li>
                                        <a href={`${SERVER_}anexo/${anexo.uuid}`} target="_blank">{anexo.idtipo_documento.documento}</a>
                                        {
                                        // JSON.stringify(anexo.idtipo_documento)
                                      }
                                      </li>
                                  )
                              }

                            </React.Fragment>
                          )
                      }
                    </ol>


                </React.Fragment>
              )
          }


          
          { visita.idresponsable !== null && (<small>Responsable</small>)}
          { visita.idresponsable !== null && (<p className="nm"><small>{visita.idresponsable.nombres} {visita.idresponsable.paterno} {visita.idresponsable.materno}</small></p>)}

          <small>Boutique</small>
          <h5>{visita.idboutique.nombre_boutique}</h5>
          <small>Estado, Municipio</small>
          <h5>{visita.idboutique.idestado.estado}, {visita.idboutique.idmunicipio.municipio}</h5>
          <small>Fecha de la Visita</small>
          <h5>{moment(visita.fecha_programada).format('DD [DE] MMMM [DE] YYYY').toUpperCase()}</h5>

          {
            // JSON.stringify(visita)
          }



          <hr className="style-one" />

{
  // JSON.stringify(tiene_acceso.tiene_acceso.archivo)
}


                      {
                        !tiene_acceso.tiene_acceso?.archivo && (
                            <React.Fragment>


          <p className="nm"><i className="fa fa-warning"/> Para poder brindar el servicio debes cargar el documento de permiso de acceso</p>



          <div className="mt-4 mb-4">
            <label htmlFor="formFileLg" className="form-label">Archivo para subir</label>
            <input className="form-control form-control-lg mb-2" id="formFileLg" type="file" accept="application/pdf" onChange={(event)=>{ handleFileRead(event); }} />
            <div className="form-text">
              <p>Únicamente se permiten archivos en formato PDF</p>
            </div>
          </div>

          <button type="button" onClick={enviarAnexo} disabled={anexo_archivo_subir===''} className="btn btn-primary">Cargar Acceso</button>


                            </React.Fragment>
                          )
                      }


                      {
                        tiene_acceso.tiene_acceso?.archivo && (
                            <React.Fragment>
                                <div className="alert alert-primary mt-4" role="alert">
                                    <p className="nm">El documento de permiso de acceso ha sido cargado </p>
                                    <a href={`${SERVER_}anexo_acceso/${tiene_acceso.tiene_acceso.uuid}`}  target="_blank">Ver Anexo de Acceso</a> <i onClick={(e:any)=>{eliminarPermisoAcceso(e,tiene_acceso.tiene_acceso.uuid)}} className="fa fa-trash"/>
                                </div>
                            </React.Fragment>
                          )
                      }








        </Modal.Body>
      </Modal>
    </>
  );
}


export default ModalCargarAccesos;